import { MapPin, Calendar, Clock, CheckCircle2, Plus, Video, Edit, CalendarPlus, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";

export const MeetingsTab = ({ project, onScheduleMeeting, handleEditMeeting, downloadCalendar, openSummaryModal }) => (
  <TabsContent value="meetings" className="animate-fade-in">
    <div className="bg-[#1A1A1A] border border-[#262626] rounded p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white">Meetings & Minutes</h3>
        <Button onClick={onScheduleMeeting} className="bg-[#FF4500] hover:bg-[#E65100]">
          <Plus className="w-4 h-4 mr-2" /> Schedule Meeting
        </Button>
      </div>

      {project.meetings?.length > 0 ? (
        <div className="space-y-4">
          {project.meetings.map((meeting, idx) => (
            <div key={meeting.meeting_id || idx} className={`p-4 bg-[#171717] rounded border border-[#262626] ${meeting.meeting_type === 'online' ? 'meeting-online' : 'meeting-site'}`}>
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    {meeting.meeting_type === 'online' ? <Video className="w-4 h-4 text-[#3B82F6]" /> : <MapPin className="w-4 h-4 text-[#10B981]" />}
                    <span className="text-sm font-medium text-white">{meeting.meeting_type === 'online' ? 'Online Meeting' : 'Site Meeting'}</span>
                  </div>
                  <p className="text-gray-400">{meeting.agenda}</p>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`badge ${meeting.status === 'completed' ? 'status-completed' : meeting.status === 'cancelled' ? 'bg-red-500/20 text-red-400' : 'status-pending'}`}>{meeting.status}</span>
                  {meeting.status === 'scheduled' && (
                    <>
                      <button onClick={() => handleEditMeeting(meeting)} className="p-1.5 rounded hover:bg-[#262626]" title="Reschedule">
                        <Edit className="w-4 h-4 text-gray-400" />
                      </button>
                      <button onClick={() => downloadCalendar('meeting', meeting.meeting_id)} className="p-1.5 rounded hover:bg-[#262626]" title="Add to Calendar">
                        <CalendarPlus className="w-4 h-4 text-[#3B82F6]" />
                      </button>
                      <button
                        onClick={() => openSummaryModal(meeting, 'meeting')}
                        className="p-1.5 rounded hover:bg-[#262626] flex items-center gap-1"
                        title="Send Summary to Client"
                        data-testid="send-meeting-summary"
                      >
                        <Send className="w-4 h-4 text-[#10B981]" />
                      </button>
                    </>
                  )}
                  {meeting.status === 'completed' && !meeting.summary_sent && (
                    <button
                      onClick={() => openSummaryModal(meeting, 'meeting')}
                      className="px-2 py-1 rounded bg-[#10B981]/20 hover:bg-[#10B981]/30 flex items-center gap-1 text-xs text-[#10B981]"
                      title="Send Summary to Client"
                    >
                      <Send className="w-3 h-3" /> Send Summary
                    </button>
                  )}
                  {meeting.summary_sent && (
                    <span className="px-2 py-1 rounded bg-gray-500/20 text-gray-400 text-xs flex items-center gap-1">
                      <CheckCircle2 className="w-3 h-3" /> Summary Sent
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-4 text-xs text-gray-500 mb-3">
                <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{meeting.scheduled_date}</span>
                <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{meeting.scheduled_time}</span>
                {meeting.location && <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{meeting.location}</span>}
              </div>
              {meeting.rescheduled_from && (
                <p className="text-xs text-[#F59E0B] mb-2">Rescheduled from: {meeting.rescheduled_from}</p>
              )}
              {meeting.minutes && (
                <div className="mt-3 p-3 bg-[#262626] rounded">
                  <p className="text-xs text-gray-500 mb-1">Minutes:</p>
                  <p className="text-sm text-gray-300 whitespace-pre-wrap">{meeting.minutes}</p>
                </div>
              )}
              {meeting.changes_discussed?.length > 0 && (
                <div className="mt-2">
                  <p className="text-xs text-gray-500 mb-1">Changes Discussed:</p>
                  <div className="flex flex-wrap gap-2">
                    {meeting.changes_discussed.map((change, i) => (
                      <span key={i} className="px-2 py-1 bg-[#F59E0B]/20 text-[#F59E0B] text-xs rounded">{change}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <Video className="w-12 h-12 text-gray-600 mx-auto mb-4" />
          <p className="text-gray-500">No meetings scheduled yet</p>
        </div>
      )}
    </div>
  </TabsContent>
);
